// eslint-disable-next-line simple-import-sort/imports -- keep English import on top
import en from './en/main.json'
import es from './es/main.json'
import de from './de/main.json'
import fr from './fr/main.json'
import id from './id/main.json'
import ko from './ko/main.json'
import pt from './pt/main.json'
import ru from './ru/main.json'
import tr from './tr/main.json'
import uk from './uk/main.json'
import zh from './zh/main.json'

export const translations: any = { en, es, de, fr, id, ko, pt, ru, tr, uk, zh }
